import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";
import moment from "moment";
import { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";

import { useAuth } from "hooks/useAuth";

export default function NiapClearPostingVerifier({
  product,
  readyToPostChecks,
  setReadyToPostChecks,
  refetch,
}) {
  const { authToken, csrfToken } = useAuth();
  const [error, setError] = useState(null);

  const handleClearValidator = () => {
    let array = readyToPostChecks;
    const updatedArray = array.map((obj) => {
      const updatedObj = { ...obj };
      for (let key in updatedObj) {
        updatedObj[key] = false;
      }
      return updatedObj;
    });
    setReadyToPostChecks(updatedArray);

    axios
      .put(
        `${import.meta.env.VITE_DJANGO_ENDPOINT}project/product/handle_remove_posting_recommendation/`,
        { product_id: product?.product_id },
        {
          withCredentials: true,
          headers: {
            Authorization: `Token ${authToken}`,
            "X-CSRFToken": csrfToken,
          },
        },
      )
      .then(() => {
        refetch();
      })
      .catch((error) => {
        setError(error.response.data.error);
      });
  };

  return (
    <Row className="border-bottom border-top border-dark pt-3 pb-3">
      {error && (
        <Col xs={12}>
          <p className="text-danger">{error}</p>
        </Col>
      )}
      <Col lg={2} className="m-auto">
        <p className="m-0">Verified By: </p>
      </Col>
      <Col lg={1} className="m-auto">
        <CheckCircleIcon style={{ color: "var(--bs-green)" }} />
      </Col>
      <Col className="m-auto">
        <p className="m-0">
          {product?.validator_posting_verifier?.first_name}{" "}
          {product?.validator_posting_verifier?.last_name},{" "}
          {product?.validator_posting_verifier?.user_role?.role_name} on{" "}
          {moment.utc(product?.validator_posting_date).format("MM/DD/YYYY")}
        </p>
      </Col>
      <Col className="m-auto">
        <Button
          variant="warning"
          className="rounded-pill"
          onClick={() => {
            handleClearValidator();
          }}
        >
          Clear Posting Recommendation
        </Button>
      </Col>
    </Row>
  );
}
